import styled from "styled-components";

export const Disable2FAContent = styled.div`
  padding-top: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px
`;
